var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 24,
    viewBox: "0 0 154 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 14L154 23.547L154 0.452995L134 10L134 14ZM142.45 10L134.75 10L134.75 14L142.45 14L142.45 10ZM127.05 10L119.35 10L119.35 14L127.05 14L127.05 10ZM111.65 10L103.95 10L103.95 14L111.65 14L111.65 10ZM96.25 10L88.55 10L88.55 14L96.25 14L96.25 10ZM80.85 10L73.15 10L73.15 14L80.85 14L80.85 10ZM65.45 10L57.75 10L57.75 14L65.45 14L65.45 10ZM50.05 10L42.35 10L42.35 14L50.05 14L50.05 10ZM34.65 10L26.95 10L26.95 14L34.65 14L34.65 10ZM19.25 10L11.55 10L11.55 14L19.25 14L19.25 10ZM3.85003 10L2.37782e-06 10L2.86739e-06 14L3.85003 14L3.85003 10Z",
    fill: "#094F9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/Line.5e4c6f81e4124f380400a8477ac57d1a.svg";
export { ForwardRef as ReactComponent };